/* Kvadrat-stijl swatch-grid — koppelt aan Dawn's <variant-selects>.
   Dawn vervangt het <variant-selects>-element bij elke variantwissel, dus:
   nooit referenties cachen — altijd vers opzoeken, en via delegatie binden. */
(function () {
  var root = document.querySelector('[data-stof-swatch]');
  if (!root) return;

  var section = root.closest('.shopify-section');
  if (section) section.classList.add('stof-has-swatch');

  function grid() { return root.querySelector('.stof-swatch__grid'); }
  function currentEl() { return root.querySelector('[data-stof-swatch-current]'); }

  function selectValue(value) {
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var radio = vs.querySelector(
      'input[type="radio"][value="' + (window.CSS && CSS.escape ? CSS.escape(value) : value) + '"]'
    );
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var select = vs.querySelector('select');
    if (select) {
      select.value = value;
      Array.prototype.forEach.call(select.options, function (o) {
        if (o.value === value) o.setAttribute('selected', 'selected');
        else o.removeAttribute('selected');
      });
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function highlight(value) {
    var g = grid();
    if (!g) return;
    g.querySelectorAll('.stof-swatch__item').forEach(function (b) {
      var on = b.dataset.value === value;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var cur = currentEl();
    if (cur && value) cur.textContent = value;
  }

  // Klik op een swatch — via delegatie zodat het DOM-swaps overleeft.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.stof-swatch__item');
    if (!btn || !root.contains(btn)) return;
    var value = btn.dataset.value;
    highlight(value);
    selectValue(value);
  });

  // Variant wijzigt (door ons of door Dawn / ?variant=) → grid meelaten lopen.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('variant-selects input[type="radio"]')) {
      if (t.checked) highlight(t.value);
    } else if (t.matches('variant-selects select')) {
      highlight(t.value);
    }
  });

  // Na een re-render van de productinfo: selectie opnieuw uitlijnen.
  document.addEventListener('DOMContentLoaded', syncFromDom);
  window.addEventListener('pageshow', syncFromDom);
  function syncFromDom() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var checked = vs.querySelector('input[type="radio"]:checked');
    var val = checked ? checked.value : (vs.querySelector('select') ? vs.querySelector('select').value : null);
    if (val) highlight(val);
  }
  syncFromDom();
})();
